import {  Route, Routes } from 'react-router-dom';
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ProtectedRoutes from "./component/ProtectedRoutes";
import PublicRoutes from "./component/PublicRoutes";
import Login from "./component/login";
import Dashboard from './component/dashboard';



function App() {
    return (
        <>
            <RouteScrollToTop />
           
                
                <Routes>
                  
                    <Route path="/" element={<ProtectedRoutes />}>
                    <Route path="/admin/*" element={<Dashboard />} />
                    
                </Route>

                   
                <Route path="/" element={<PublicRoutes />}>
                    <Route index element={<Login />} />
                </Route>

                 
                </Routes>
            
        </>
    );
}

export default App;
